import * as React from "react";
const ShadowBold = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15,13 L15,7 C15,5.896 14.104,5 13,5 L7,5 C5.896,5 5,5.896 5,7 L5,13 C5,14.104 5.896,15 7,15 L13,15 C14.104,15 15,14.104 15,13 L15,13 Z M17,7 L17,14.5 C17,15.875 15.875,17 14.5,17 L8,17 L8,19 L15,19 C17.209,19 19,17.209 19,15 L19,7 L17,7 Z" }));
ShadowBold.displayName = "ShadowBold";
var ShadowBold_default = ShadowBold;
export {
  ShadowBold_default as default
};
